import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { PmaxPreviewData } from '../../../../../../../models/google-template/preview-interfaces/pmax-preview-data.interface';
import { UrlDisplayHelper } from '../../../../../../../utils/url-display-helper';
import { DesktopFrameComponent } from '../../../preview-common/desktop-frame/desktop-frame.component';

/**
 * Performance Max on the Google search results page (desktop): the local ad
 * with location details, a location photo plus map tile and action chips.
 */
@Component({
  selector: 'app-pmax-google-search-desktop-02',
  imports: [CommonModule, DesktopFrameComponent],
  templateUrl: './google-search-desktop-02.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './google-search-desktop-02.component.scss'
})
export class PmaxGoogleSearchDesktop02PreviewComponent {
  @Input() data!: PmaxPreviewData;

  /** Skeleton tab widths under the search box, in px. */
  readonly tabWidths = [36, 67, 80, 64, 56];

  /** Google joins up to two headlines. */
  get headline(): string {
    return this.data.headlines.slice(0, 2).join(' - ') || 'Your headlines appear here';
  }

  /** Static hotel photo standing in for the Business Profile location image. */
  readonly locationImage = 'assets/images/pmax-preview-hotels/pical.jpg';

  get description(): string {
    return this.data.descriptions.slice(0, 2).join(' ') || 'Your descriptions appear here.';
  }

  /** Host plus path of the destination URL, without scheme or query. */
  get displayUrl(): string {
    const host = UrlDisplayHelper.hostOf(this.data.url);
    try {
      const path = new URL(this.data.url).pathname.replace(/\/+$/, '');
      return host + path;
    } catch {
      return host;
    }
  }
}
